import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@STORE/index';

import { 
    sectionIntroductionTextModalSlice, 
    SectionIntroductionTextModalDispatchParams, 
    SectionIntroductionTextModalState,
} from '@REDUCERS';

function createSectionIntroductionTextModalHook() {
    return function useSectionIntroductionTextModal(equalityFn?: EqualityFn<SectionIntroductionTextModalState>) {
        const state = useAppSelector((store) => store.sectionIntroductionTextModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: SectionIntroductionTextModalDispatchParams) => dispatch(sectionIntroductionTextModalSlice.actions.open(params)),
            close: () => dispatch(sectionIntroductionTextModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createSectionIntroductionTextModalHook(); 